import React from "react";
import { LuChevronDown } from "react-icons/lu";

export const KeyAspectsFonts = ({ data, setData }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      keyAspectsFonts: { ...prev.keyAspectsFonts, [name]: value },
    }));
  };

  return (
    <div className="bg-[#F0F0F0] dark:bg-[#282828] p-4 rounded-lg my-4">
      <div className="flex items-center space-x-2">
        <div className="bg-[#CBF0D0] w-4 h-4 rounded" />
        <h1>Key Aspects</h1>
      </div>

      <div className="py-4 grid md:grid-cols-2 gap-4">
      <div className="w-full relative">
          <label htmlFor="" className="">
            Category
          </label>
          <div className="bg-white dark:bg-[#1C1C1C] dark:border-[#5B5B5B]  rounded-lg my-2">
            <select
              value={data.keyAspectsFonts?.category || ""}
              onChange={handleChange}
              name="category"
              className="custom-select w-full bg-transparent p-2"
            >
              <option value="" className="opacity-60">
                Serif
              </option>
              <option value="food">San JJ</option>
              <option value="drink">San HH</option>
              <option value="tech">Tech</option>
            </select>
            <LuChevronDown className='text-xl  absolute right-2 top-[45px]'/>
          </div>
        </div>
        <div className="w-full relative">
          <label htmlFor="" className="">
            Style <span>(separate values by comma)</span>
          </label>
          <div className="bg-white dark:bg-[#1C1C1C] dark:border-[#5B5B5B]  rounded-lg my-2">
            <select
              value={data.keyAspectsFonts?.style || ""}
              onChange={handleChange}
              name="style"
              className="custom-select w-full bg-transparent p-2"
            >
              <option value="" className="opacity-60">
                e.q Food & Drink
              </option>
              <option value="food">Food</option>
              <option value="drink">Drink</option>
              <option value="tech">Tech</option>
            </select>
            <LuChevronDown className='text-xl  absolute right-2 top-[45px]'/>
          </div>
        </div>

        <div className="">
          <label htmlFor="" className="">
            Weights <span>(separate values by comma)</span>
          </label>
          <div className="bg-white dark:bg-[#1C1C1C] dark:border-[#5B5B5B]  rounded-lg my-2">
            <input
             value={data.keyAspectsFonts?.weights || ""}
             onChange={handleChange}
             name="weights"
              type="text"
              placeholder="e.q light, regular"
              className="w-full p-2 bg-transparent"
            />
          </div>
        </div>

        <div className="">
          <label htmlFor="" className="">
            Type <span>(separate values by comma)</span>
          </label>
          <div className="bg-white dark:bg-[#1C1C1C] dark:border-[#5B5B5B]  rounded-lg my-2">
            <input
             value={data.keyAspectsFonts?.type || ""}
             onChange={handleChange}
             name="type"
              type="text"
              placeholder="e.q variable"
              className="w-full p-2 bg-transparent"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
